// extracted by mini-css-extract-plugin
export default {"noPadding":"styles_noPadding__YK2SX","centerContent":"styles_centerContent__ibjq9","loading":"styles_loading__t-Yys","title":"styles_title__foBB5"};